import { capitalize } from './funciones';
import moment from 'moment';

export const dataParse = (data) => {
  return Object.entries(data)
    .map(([key, value]) => parseHandler(key, value))
    .join('\n');
};

export const parseHandler = (key, value) => {
  switch (key) {
    case '_id':
      return ``;
    case '__v':
      return ``;
    case 'membershipStatus':
      return `Estatus de la Membresia: ${capitalize(value)}`;
    case 'isActive':
      return `Activo: ${value ? 'Si' : 'No'}`;
    case 'createdAt':
      return `Creacion: ${moment(value).format('DD/MM/YYYY LTS')}`;
    case 'updatedAt':
      return `Edicion: ${moment(value).format('DD/MM/YYYY LTS')}`;
    case 'membershipStatusId':
      return `Estatus de la Membresia: ${value}`;
    case 'email':
      return `Correo: ${value}`;
    case 'firstName':
      return `Nombre: ${value}`;
    case 'lastName':
      return `Apellido: ${value}`;
    case 'gender':
      return `Genero: ${value}`;
    case 'identificationType':
      return `Cedula: ${value}`;
    case 'identification':
      return `${value}`;
    case 'phonePrefix':
      return `Telefono: ${value}`;
    case 'phoneNumber':
      return `${value}`;
    case 'optionalPhonePrefix':
      if (value) return `Telefono Opcional: ${value}`;
      else return;
    case 'optionalPhoneNumber':
      if (value) return `${value}`;
      else return;
    case 'maritalStatus':
      return `Estado Civil ${value}`;
    case 'licenses':
      if (value && value.length > 0) {
        return `Licencias: ${value.map((license) => license.name).join(', ')}`;
      } else return;
    case 'type':
      return `Tipo: ${value}`;
    case 'cases':
      if (value && value.length > 0) {
        return `Casos: ${value.map((license) => license.name).join(', ')}`;
      } else return;
    case 'contactPersons':
      if (value && value.length > 0) {
        return `Contactos: ${value.map((license) => license.name).join(', ')}`;
      } else return;

    //   Precios
    case 'finalPrice':
      return `Precio Final ${value}`;
    case 'finalPriceInBsS':
      return `Precio Final Bs ${value}`;
    //   Recargos
    case 'medCertSurcharge':
      return `Recargo Cert Medico ${value}`;
    case 'yearSurcharge':
      return `Recargo antiguedad ${value}`;
    case 'armorTypeSurcharge':
      return `Recargo Blindaje ${value}`;
    case 'kmSurcharge':
      return `Recargo Km ${value}`;

    default:
      return `${key}: ${value}`;
  }
};

export const parseHandler2 = (key, value) => {
  return `${key}: ${value}`;
};

// Parse a date string into a JS Date supporting multiple formats.
// Returns a Date when valid, otherwise returns an empty string
// Supported formats: 'YYYY-MM-DD', 'DD/MM/YYYY'
export const parseDateFlexible = (input) => {
  if (!input) return '';

  // If already a Date instance, return a copy
  if (input instanceof Date && !isNaN(input)) {
    return new Date(input.getTime());
  }

  // Try strict parsing with known formats
  const m = moment(input, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
  if (m.isValid()) {
    return m.toDate();
  }

  // Fallback: try moment's loose parsing (ISO or other recognizable formats)
  const loose = moment(input);
  if (loose.isValid()) {
    return loose.toDate();
  }

  return '';
};
